import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Search from "~components/Search";
import WalletLayout from "../components/WalletLayout";
import { Spinner } from "@chakra-ui/react";
import { useConfigureFooter } from "~hooks/useHelpers";
// import useClientes from "~/fetchs/useClientes";
import useProspects from "~/fetchs/useProspects";
import SearchList from "../SearchList";
import StatusModal from "~components/Modal/ModalStatus";
import useModalStatus from "~components/Modal/hooks/useModalStatus";

const Prospect = () => {
  useConfigureFooter();

  const [loadingSearch, setLoadingSearch] = useState(false);

  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(6);

  const { prospects, total, searchTerm, handleSearch, totalProspecs, loadingCached, loadingRequest } = useProspects({
    type: 'prospect',
    take,
    skip,
    setLoadingSearch
  });

  const location = useLocation();
  const navigate = useNavigate();
  const { isModalOpenStatus, closeModalStatus, openModalStatus } = useModalStatus();

  useEffect(() => {
    if (location.state?.successProspectUpdated) {
      openModalStatus();
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.successProspectUpdated]);


  return (
    <WalletLayout>
      <Search
        searchTerm={searchTerm}
        initialValue={searchTerm}
        onSearch={handleSearch}
        placeholder="Buscar cliente por código Prospect"
        textButton="Novo Prospect"
        setLoading={setLoadingSearch}
        total={totalProspecs}
      />

      {(loadingSearch || loadingCached) ? (
        <div className="container flex items-center justify-center pt-10">
          <Spinner size={"xl"} thickness="4px" />
        </div>
      ) : (
        <SearchList items={prospects} value={searchTerm} total={total} skip={skip} take={take} setSkip={setSkip} hideOthersButtons={true} loadingRequest={loadingRequest} />
      )}

      <StatusModal
        isOpen={isModalOpenStatus}
        onClose={closeModalStatus}
        title="Prospect salvo com sucesso!"
        buttonOne="Ok"
        buttonTwo={null}
        linkOne={null}
        linkTwo={null}
      />
    </WalletLayout>
  );
};

export default Prospect;
